import destroy from './destroy';
import store from './store';
import show from './show';
import update from './update';
import all from './all';
import items from './items';

export default {
  destroy,
  store,
  show,
  update,
  all,
  items,
};



// WEBPACK FOOTER //
// ./src/app/services/unitOfMeasure/index.js